import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { InfoButtonFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import styled from 'styled-components';

export const DISABLED_BACKGROUND_ALPHA = '73';

export const QuoteExperienceOptionStyled = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
`;

export const DescriptionBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-grow: 1;
`;

export const DescriptionBlockTitleStyled = styled.h3`
  ${typography.bold[16]}
  color: ${colors.neutral[900]};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const DescriptionBlockDescriptionStyled = styled.p`
  ${typography.regular[16]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const IconWrapperStyled = styled.div<{ $accentColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 5rem;
  height: 5rem;
  background-color: ${({ $accentColor }): string => $accentColor};
  border-radius: 10px;
  padding: 0.5rem;
  box-sizing: border-box;
`;

export const DisabledReasonBlockStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-top: 2rem;
`;

export const DisabledReasonTextStyled = styled.span`
  ${typography.regular[14]}
  color: ${colors.indigo[600]};
`;

export const InfoButtonFilledStyled = styled(InfoButtonFilled)`
  flex-shrink: 0;
`;
